import React, { useState } from "react";

type Lado = "izquierda" | "derecha";
type Tipo = "M" | "C";

interface Personaje {
  id: number;
  tipo: Tipo;
  lado: Lado;
  seleccionado: boolean;
}

const inicial: Personaje[] = [
  { id: 1, tipo: "M", lado: "izquierda", seleccionado: false },
  { id: 2, tipo: "M", lado: "izquierda", seleccionado: false },
  { id: 3, tipo: "M", lado: "izquierda", seleccionado: false },
  { id: 4, tipo: "C", lado: "izquierda", seleccionado: false },
  { id: 5, tipo: "C", lado: "izquierda", seleccionado: false },
  { id: 6, tipo: "C", lado: "izquierda", seleccionado: false },
];

export default function MisionerosCanibalesPage() {
  const [personajes, setPersonajes] = useState<Personaje[]>(inicial);
  const [bote, setBote] = useState<Lado>("izquierda");
  const [movimientos, setMovimientos] = useState(0);
  const [mensaje, setMensaje] = useState("");
  const [finalizado, setFinalizado] = useState(false);

  const puntaje = movimientos <= 11 ? 100 : Math.max(0, 100 - (movimientos - 11) * 5);

  const seleccionar = (id: number) => {
    if (finalizado) return;

    const personaje = personajes.find((p) => p.id === id);
    if (!personaje || personaje.lado !== bote) {
      alert("Ese personaje no está del lado del bote.");
      return;
    }

    const seleccionados = personajes.filter((p) => p.seleccionado);

    if (!personaje.seleccionado && seleccionados.length >= 2) {
      alert("El bote solo puede llevar hasta 2 personas.");
      return;
    }

    setPersonajes((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, seleccionado: !p.seleccionado } : p
      )
    );
  };

  const ladoValido = (lista: Personaje[], lado: Lado) => {
    const m = lista.filter((p) => p.lado === lado && p.tipo === "M").length;
    const c = lista.filter((p) => p.lado === lado && p.tipo === "C").length;
    return m === 0 || m >= c;
  };

  const cruzar = () => {
    if (finalizado) return;

    const seleccionados = personajes.filter((p) => p.seleccionado);

    if (seleccionados.length === 0) {
      alert("Seleccioná al menos una persona.");
      return;
    }

    const nuevoLado: Lado = bote === "izquierda" ? "derecha" : "izquierda";

    const nuevosPersonajes = personajes.map((p) =>
      p.seleccionado
        ? { ...p, lado: nuevoLado, seleccionado: false }
        : p
    );

    const nuevosMovimientos = movimientos + 1;

    setPersonajes(nuevosPersonajes);
    setBote(nuevoLado);
    setMovimientos(nuevosMovimientos);

    if (!ladoValido(nuevosPersonajes, "izquierda") || !ladoValido(nuevosPersonajes, "derecha")) {
      setMensaje("❌ Perdiste: los caníbales superaron a los misioneros.");
      setFinalizado(true);
      return;
    }

    if (nuevosPersonajes.every((p) => p.lado === "derecha")) {
      const finalScore =
        nuevosMovimientos <= 11 ? 100 : Math.max(0, 100 - (nuevosMovimientos - 11) * 5);

      setMensaje(`✅ ¡Ganaste! Movimientos: ${nuevosMovimientos} | Puntaje: ${finalScore}`);
      setFinalizado(true);
    }
  };

  const reiniciar = () => {
    setPersonajes(inicial);
    setBote("izquierda");
    setMovimientos(0);
    setMensaje("");
    setFinalizado(false);
  };

  const renderPersonajes = (lado: Lado) =>
    personajes
      .filter((p) => p.lado === lado)
      .map((p) => (
        <div
          key={p.id}
          className={`persona ${p.seleccionado ? "seleccionado" : ""}`}
          onClick={() => seleccionar(p.id)}
        >
          {p.tipo === "M" ? "👨‍🦱" : "🧟"}
          <span>{p.tipo === "M" ? "Misionero" : "Caníbal"}</span>
        </div>
      ));

  return (
    <div className="mc-page">
      <h1>🚤 Misioneros y Caníbales</h1>
      <p>Seleccioná 1 o 2 personajes del lado donde está el bote y cruzá el río.</p>

      <div className="panel">
        <div className="dato">Movimientos: {movimientos}</div>
        <div className="dato">Puntaje: {puntaje}</div>
      </div>

      <div className="contenedor">
        <div className="orilla">
          <div className="titulo">Orilla izquierda</div>
          <div className="zona-personajes">{renderPersonajes("izquierda")}</div>
        </div>

        <div className="rio">
          <div className="ola"></div>
          <div className="ola"></div>
          <div className="ola"></div>
          <div className={`bote ${bote}`}>🚤 Bote</div>
        </div>

        <div className="orilla">
          <div className="titulo">Orilla derecha</div>
          <div className="zona-personajes">{renderPersonajes("derecha")}</div>
        </div>
      </div>

      <button onClick={cruzar}>Cruzar río</button>
      <button onClick={reiniciar}>Reiniciar</button>

      <div className="mensaje">{mensaje}</div>

      <style>{`
        .mc-page {
          text-align: center;
          min-height: 100vh;
          background: linear-gradient(#b7e7ff, #eaf8ff);
          padding: 10px;
        }

        .panel {
          display: flex;
          justify-content: center;
          gap: 15px;
          flex-wrap: wrap;
          margin: 10px;
        }

        .dato {
          background: white;
          padding: 10px 18px;
          border-radius: 12px;
          font-weight: bold;
          box-shadow: 0 2px 8px #999;
        }

        .contenedor {
          display: grid;
          grid-template-columns: 1fr 1.2fr 1fr;
          height: 520px;
          margin: 20px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 0 20px #777;
        }

        .orilla {
          background: linear-gradient(#59b957, #2f8f3a);
          padding: 20px;
        }

        .rio {
          background: linear-gradient(#3ba7e8, #0b6fae);
          position: relative;
          overflow: hidden;
        }

        .titulo {
          font-weight: bold;
          color: white;
          text-shadow: 1px 1px 3px #000;
        }

        .zona-personajes {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
          margin-top: 40px;
        }

        .persona {
          width: 55px;
          height: 65px;
          background: white;
          border-radius: 12px;
          border: 3px solid #333;
          font-size: 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          cursor: pointer;
        }

        .persona span {
          font-size: 11px;
          font-weight: bold;
        }

        .seleccionado {
          background: #ffcc4d;
          border-color: #ff6600;
          transform: scale(1.1);
        }

        .bote {
          position: absolute;
          bottom: 120px;
          width: 150px;
          height: 80px;
          background: #8b4513;
          border-radius: 0 0 70px 70px;
          border: 4px solid #4b260b;
          transition: left 1.2s ease-in-out;
          color: white;
          font-weight: bold;
          padding-top: 20px;
          box-sizing: border-box;
        }

        .bote.izquierda {
          left: 20px;
        }

        .bote.derecha {
          left: calc(100% - 180px);
        }

        .ola {
          position: absolute;
          width: 200%;
          height: 30px;
          background: rgba(255,255,255,0.4);
          border-radius: 50%;
          animation: moverOla 4s linear infinite;
        }

        .ola:nth-child(1) { top: 100px; }
        .ola:nth-child(2) { top: 220px; animation-delay: 1s; }
        .ola:nth-child(3) { top: 350px; animation-delay: 2s; }

        @keyframes moverOla {
          from { left: -100%; }
          to { left: 100%; }
        }

        button {
          padding: 12px 22px;
          margin: 8px;
          border: none;
          border-radius: 12px;
          background: #E9681F;
          color: white;
          font-size: 16px;
          cursor: pointer;
        }

        button:hover {
          background: #c85617;
        }

        .mensaje {
          font-size: 20px;
          font-weight: bold;
          margin: 15px;
        }

        @media (max-width: 768px) {
          .contenedor {
            grid-template-columns: 1fr;
            height: auto;
            margin: 10px;
          }

          .orilla, .rio {
            min-height: 150px;
            padding: 15px;
          }

          .rio {
            order: 2;
            min-height: 120px;
          }

          .orilla:first-child {
            order: 1;
          }

          .orilla:last-child {
            order: 3;
          }

          .persona {
            width: 45px;
            height: 55px;
            font-size: 20px;
          }

          .persona span {
            font-size: 9px;
          }

          .bote {
            position: relative;
            width: 120px;
            height: 60px;
            margin: 20px auto;
            left: 0 !important;
            bottom: 0;
            transition: none;
          }
        }
      `}</style>
    </div>
  );
}